import React, {useState, useEffect, useContext} from 'react'
import './ScreenLoader.css'

export default function ScreenLoader() {
    return (
        <div id="loader-wrapper">
                <div id="loader"></div>
                <div className="loader-section section-left"></div>
                <div className="loader-section section-right"></div>
        </div>
  )
};